import React from "react";
import { Tabs } from "antd";

const DocumentsTabUi = ({ tabId, setTabId }) => {
    return (
      <Tabs
        className="mx-2 text-base"
        popupClassName="mb-0"
        tabBarStyle={{
          marginBottom: 0,
        }}
        activeKey={tabId}
        defaultActiveKey={tabId}
        items={[
          { label: "All documents", key: "all" },
          { label: "New", key: "new" },
          { label: "With internal document", key: "with_internal" },
        ]}
        onChange={(value) => {
          setTabId(value);
        }}
      />
    );
  };

export default DocumentsTabUi; 